import * as React from 'react';
import { styled, Box } from '@mui/material';

const OuterContainer = styled('div')(({ theme }) => ({
  background: (theme.palette as any).blue?.light || '#e3f2fd',
  padding: '5px',
  borderRadius: '20px',
  width: '30%',
  margin: 'auto',
  boxSizing: 'border-box',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19)',
  position: 'relative',
  [theme.breakpoints.down('xl')]: { width: '40%' },
  [theme.breakpoints.down('lg')]: { width: '40%' },
  [theme.breakpoints.down('md')]: { width: '60%' },
  [theme.breakpoints.down('sm')]: { width: '98%' },
}));

const InnerContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '15px',
  padding: '2.6em',
  textAlign: 'center',
  boxSizing: 'border-box',
  width: '100%',
  position: 'relative',
  [theme.breakpoints.down('xl')]: {
    padding: '1em',
    fontSize: '0.9em',
  },
}));

const ConnectFormContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <OuterContainer>
    <InnerContainer>
      <Box
        sx={(theme) => ({
          position: 'absolute',
          top: '1em',
          right: '1em',
          [theme.breakpoints.down('sm')]: {
            position: 'relative',
            top: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            mb: 1,
          },
        })}
      />
      {children}
    </InnerContainer>
  </OuterContainer>
);

export default ConnectFormContainer;

